import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, MessageBar, MessageBarType, CommandBar } from '@fluentui/react';
import { api } from '../services/api';
import type { SpawnRequest } from '../types';
import SpawnForm from '../components/SpawnForm';
import styles from './SpawnBox.module.css';

export default function SpawnBox() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(req: SpawnRequest) {
    setIsSubmitting(true);
    setError('');
    try {
      const { instanceId, operationId } = await api.spawnInstance(req);
      navigate(`/instances/${instanceId}?operationId=${encodeURIComponent(operationId)}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to spawn instance');
      setIsSubmitting(false);
    }
  }

  return (
    <div className={styles.page}>
      <CommandBar
        items={[{ key: 'back', iconOnly: true, iconProps: { iconName: 'Back' }, onClick: () => { navigate('/'); }, ariaLabel: 'Back' }]}
        styles={{ root: { borderBottom: '1px solid var(--ab-border)', background: 'var(--ab-bg-command-bar)', padding: '0 8px' } }}
      />
      <div className={styles.formHeader}>
        <Text variant="xLarge" styles={{ root: { fontWeight: 600 } }}>New Instance</Text>
      </div>
      <div className={styles.body}>
        {error && (
          <MessageBar messageBarType={MessageBarType.error} onDismiss={() => setError('')} isMultiline={false}>
            {error}
          </MessageBar>
        )}
        <SpawnForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
      </div>
    </div>
  );
}
